import { eventEmitter } from "../eventEmitters/EventEmitters";
import { session } from "../services/session";
import storage from "./storage";


interface MetricsData {
  totalSession: number;
  // The historical dock's own running total of converted sessions, kept in
  // lockstep with totalSession by every code path that increments it
  // (clusterService.ts's getHistoricalBubblesData/applyDepartedSessionsBulk/
  // moveBubbleToHistoricalCluster) - lets each category's tooltip show its
  // share of ALL conversions (converted / totalConverted), matching how the
  // existing Sessions row already shows share of ALL sessions (user /
  // totalSession), not that category's own internal conversion rate.
  totalConverted: number;
  bounceRate: string;
  avgSessionDuration: string;
  newUsers: number;
  percentNewSessions: number;
  pageviewsPerSession: number;
}

// eslint-disable-next-line prefer-const
export let historical: MetricsData = {
  totalSession: 0,
  totalConverted: 0,
  bounceRate: 0 + "%",
  avgSessionDuration: 0 + "min",
  newUsers: 0,
  percentNewSessions: 0,
  pageviewsPerSession: 0,
};
let totalPageViews: number;
 export let subscriptionPageViews: number;


 export const getSubscriptionPageViewCount = async(data:string) =>{
  const SubscriptionPageViewCount = await session({
    jsonprc: "2.0",
    method: "getSubscriptionPageViewCount",
    params: {
      userId: data,
    },
    id: 0,
  });
  subscriptionPageViews = SubscriptionPageViewCount?.data?.result;
};
// When the customer's page-view allowance next resets. Comes from the SAME
// window the usage count is computed from (MetricsService.pageViewWindow), so
// the number and the date on the Settings page always describe the same period.
export const getPageViewsRenewalDate = async (userId: string) => {
  const response = await session({
    jsonprc: "2.0",
    method: "getPageViewsRenewalDate",
    params: {
      userId,
    },
    id: 0,
  });
  return response?.data?.result ?? null;
};

export const getMetricsData = async (data: any) => {
  const requestParams = {
    id: 0,
    jsonprc: "2.0",
    method: "getMainMetrics",
    params: {
      startDate: new Date(data.startDate).toISOString(),
      endDate: data.endDate,
      siteId: storage.get("siteId"),
    },
  };
 

  const metricsData: any = await session(requestParams);
  const percentNewSessionsNumber =
    (metricsData?.data?.result?.newUsers /
      metricsData?.data?.result?.totalSession) *
      100 || 0;
  const percentNewSessions = parseFloat(percentNewSessionsNumber.toFixed(1));
  return {
    totalSession: metricsData?.data?.result?.totalSession,
    bounceRate: metricsData?.data?.result?.bounceRate,
    avgSessionDuration: metricsData?.data?.result?.avgSessionDuration,
    newUsers: metricsData?.data?.result?.newUsers,
    percentNewSessions,
    pageviewsPerSession: metricsData?.data?.result?.pageviewsPerSession,
    pageViews: metricsData?.data?.result?.pageViews,
    conversions: metricsData?.data?.result?.conversions,
    conversionRate: metricsData?.data?.result?.conversionRate,
  };
};



eventEmitter.addListener("newSession", () => {
  totalPageViews++;
  subscriptionPageViews++;
});

eventEmitter.addListener("sessionChanged", () => {
  totalPageViews++;
  subscriptionPageViews++;
});
export const updateSubscriptionPageViews = (data)=>{
  subscriptionPageViews = data;
};
